







import { Component, Vue, Prop } from "vue-property-decorator";
import { Synergy } from "@/models/type";
import router from "@/router";

@Component({
  name: "synergy-tooltip",
  components: {}
})
export default class SynergyTooltip extends Vue {
  @Prop({ required: true }) synergy!: Synergy;
  @Prop({ required: true }) synergyType!: "origin" | "class";
}
